import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.substring(1)).get("session_id");

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    const exchangeSession = async () => {
      try {
        const res = await axios.post(`${API}/auth/google-session`, { session_id: sessionId });
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("user", JSON.stringify(res.data.user));
        // Clear the hash from URL
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { replace: true });
      } catch (err) {
        console.error("Google auth error:", err);
        navigate("/login", { replace: true });
      }
    };

    exchangeSession();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#0B0E11] flex items-center justify-center">
      <div className="text-center">
        <div className="w-10 h-10 border-3 border-[#FCD535] border-t-transparent rounded-full animate-spin mx-auto" />
        <p className="mt-4 text-[#848E9C] text-sm">Conectando con Google...</p>
      </div>
    </div>
  );
}
